import React from "react";
import "./App.css";

export default function PageAccueil() {
  return (
    <>
      <h2
        style={{
          fontFamily: "Georgia, serif",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        La Blockchain au service de la traçabilité
      </h2>
      <br />
      <div className="image-container">
        <img
          src="fruits-and-vegetables-732x549.jpg"
          alt="fruits"
          height="300"
        />
      </div>

      <br />
      <br />
      <p>
        <b>
          <u>Comment fonctionne le système Traceur?</u>
        </b>
        <br />
        <br />
        Le système Traceur conserve de façon sécurisée les informations
        de traçabilité entrées sur le web par les fournisseurs concernant leurs
        produits et permet aux consommateurs de consulter ces informations grâce
        à l'application mobile "Cherche Youki!".
        <br />
        <br />
        La sécurité et la persistance des informations est assurée par une
        blockchain à laquelle les fournisseurs accèdent au travers d’un site
        web. Ils entrent ainsi les données relatives à chaque lot de fabrication
        au moment de sa production, en indiquant les ingrédients en provenance
        de leurs propres founisseurs. <br />
        <br />
        Le consommateur obtient ces informations par l’application mobile
        « cherche Youki ! » et peut remonter la chaîne de traçabilité lorsque
        les fournisseurs sous-traitants ont également entré leurs propres
        données, et ainsi de suite.
        <br />
        <br /> L'agroalimentaire est un domaine d'application idéal où le
        souhait de traçabilité est depuis longtemps exprimé. Le système peut
        également être utilisé dans de nombreux autres domaines de l'economie.
        <br />
        <br />
        <br />
        <b>
          <u>Qu'est-ce que la technologie Blockchain?</u>
        </b>
        <br />
        <br />
        La technologie Blockchain permet de stocker des données de façon
        immuable et d’identifier de façon indiscutable les entités qui ont
        inscrit ces données. <br />
        <br />
        Ces données sont contenues dans des blocs qui sont chaînés entre eux à
        l’aide de « cadenas » numériques cryptés (chaîne de blocs). Cette chaîne
        peut être mise à jour par plusieurs acteurs qui se chargent tour à tour
        de compléter la chaîne de blocs avec de nouveaux blocs. <br />
        <br />
        La technologie Blockchain est à la base de toutes les crypto-monnaies.
        La technologie utilisée içi (Ethereum) permet de concevoir des
        programmes entiers qui sont executés par la Blockchain. Un avantage
        majeur est alors que le code exécuté par le système « cherche Youki ! »
        est public, inscrit lui-même sur la Blockchain, et peut être analysé par
        tous.
        <br />
        <br />
        <br />
        <b>
          <u>Comment s'inscrire comme fournisseur?</u>
        </b>
        <br />
        <br />
        Pour s’inscrire comme fournisseur, il faut créer un compte sur le
        portefeuille de crypto-monnaies Metamask (extension libre et gratuite à
        rajouter à son navigateur- par exemple Chrome ou Firefox- qu’il suffit
        de télécharger). <br />
        <br />
        La procédure ensuite est de nous contacter par email
        (contact@traceur-de-lots.eu) afin de vous ouvrir un accés sur la
        Blockchain avec ce compte. Vous pourrez ensuite créer des lots,
        visualiser vos lots ainsi que tous les lots inscrits sur la Blockchain.
        <br />
        <br />
        Une formation d’une durée de deux heures vous permettra de mieux
        apprécier les avantages de la Blockchain et facilitera vos premières
        créations de lots.
        <br />
        <br />
        L'application mobile "cherche Youki!" qui permet de consulter la chaîne
        de traçabilité est disponible sur Android et IOS.
        <br />
      </p>
      {/* <img src="google-app-store.png" alt="google app store" height="100" /> */}
      <br />
      <br />
    </>
  );
}
